import { useApp } from '../context/AppContext';
import { useI18n } from '../context/I18nContext';

const PROVIDER_LABELS = {
  ollama: { label: 'Local', color: '#10b981' },
  claude: { label: 'Claude', color: '#d946ef' },
  kimi: { label: 'Kimi', color: '#f59e0b' },
  hf: { label: 'HF', color: '#f97316' },
  tchadgpt: { label: 'TchadGPT', color: '#002664' },
  zai: { label: 'Z.ai', color: '#3b82f6' },
  deepseek: { label: 'DeepSeek', color: '#4f46e5' },
  xai: { label: 'Grok', color: '#f97316' },
  chatlyai: { label: 'ChatlyAI', color: '#ec4899' },
  groq: { label: 'Groq', color: '#f43f5e' },
  mistral: { label: 'Mistral', color: '#06b6d4' },
  perplexity: { label: 'Perplexity', color: '#14b8a6' }
};

export default function InviteModal() {
  const {
    sessionId, participants, models, personas, inviteAgent, setShowInvite, saveSession
  } = useApp();
  const { t } = useI18n();

  const link = sessionId ? window.location.href : t('createSessionAndCopyLink');

  const copyLink = () => {
    if (!sessionId) return;
    navigator.clipboard.writeText(link);
  };

  const handleInviteAgent = () => {
    const personaSelect = document.getElementById('inviteAgentPersona');
    const modelSelect = document.getElementById('inviteAgentModel');
    inviteAgent(personaSelect.value, modelSelect.value);
  };

  return (
    <div className="modal-overlay show" onClick={e => e.target === e.currentTarget && setShowInvite(false)}>
      <div className="modal">
        <div className="modal-header">
          <h2>{t('inviteCollaborators')}</h2>
          <button className="modal-close" onClick={() => setShowInvite(false)}>&times;</button>
        </div>
        <div className="modal-body">
          <div className="invite-section">
            <h4>{t('shareSessionLink')}</h4>
            <p>{t('anyoneWithThisLink')}</p>
            <div className="copy-link-row">
              <input type="text" id="inviteLink" readOnly value={link} />
              <button onClick={copyLink}>{t('copy')}</button>
            </div>
            {!sessionId && <button className="btn-secondary btn-small" onClick={saveSession} style={{ marginTop: 8 }}>{t('createSessionAndCopyLink')}</button>}
          </div>

          <div className="invite-section">
            <h4>{t('inviteAIAgent')}</h4>
            <p>{t('addAnotherAIAgent')}</p>
            <div className="invite-agent-row">
              <select id="inviteAgentPersona">
                {personas.map(p => <option key={p.id} value={p.id}>{p.icon} {p.name}</option>)}
              </select>
              <select id="inviteAgentModel">
                {models.map(m => {
                  const pl = PROVIDER_LABELS[m.provider] || { label: m.provider };
                  return <option key={m.id} value={m.id}>{pl.label}: {m.name}</option>;
                })}
              </select>
              <button onClick={handleInviteAgent}>{t('addAgent')}</button>
            </div>
          </div>

          <div className="invite-section">
            <h4>{t('currentParticipants')}</h4>
            <div className="participants-list-modal">
              {participants.length === 0 && <p className="empty-participants">{t('noParticipantsYet')}</p>}
              {participants.map((p, i) => (
                <div key={i} className="participant-item">
                  <span className={`participant-dot ${p.type}`}></span>
                  <span className="participant-name">{p.name}</span>
                  <span className="participant-type">{p.type}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
